var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "m-document-create-edit" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "documents-create-edit-document-modal",
            size: "custom-size",
            "no-enforce-focus": "",
            centered: "",
            "hide-footer": "",
            "hide-header": "",
          },
          on: { show: _vm.onShowModal, close: _vm.closeModal },
          model: {
            value: _vm.localActive,
            callback: function ($$v) {
              _vm.localActive = $$v
            },
            expression: "localActive",
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "m-document-create-edit-close",
              attrs: {
                width: "15",
                height: "16",
                viewBox: "0 0 15 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
              on: { click: _vm.closeModal },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                  fill: "#8E9CBB",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                  fill: "#8E9CBB",
                },
              }),
            ]
          ),
          _c("div", { staticClass: "m-document-create-edit-title" }, [
            _c("div", [
              _vm._v(" " + _vm._s(_vm.modalTitle) + " "),
              _vm.modalInfo.isEdit
                ? _c("span", { staticClass: "updating-analyse-label" }, [
                    _vm._v(" " + _vm._s(_vm.updatingAnalyseLabel) + " "),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "position-relative" }, [
            _c("div", {
              staticClass: "m-document-create-edit-content-shadow-top",
              attrs: { id: "m-document-create-edit-content-shadow-top" },
            }),
            _c(
              "div",
              {
                staticClass: "m-document-create-edit-content",
                class: {
                  "m-document-create-edit-content-overflow":
                    _vm.appendLocalFiles.length,
                },
                attrs: { id: "m-document-create-edit-content" },
                on: { scroll: _vm.setShadowsCreateEditDocumentModal },
              },
              [
                !_vm.modalInfo.isEdit
                  ? _c("c-input-old", {
                      staticClass: "m-document-create-edit-content-select mb-4",
                      class: {
                        "m-document-create-edit-content-select-required":
                          _vm.errorMessages.analyseType.length,
                      },
                      attrs: {
                        required: _vm.errorMessages.analyseType,
                        items: _vm.analysesTypes,
                        searchable: true,
                        clearable: true,
                        type: "select",
                        "floating-label": "Тип анализа",
                      },
                      model: {
                        value: _vm.selectedAnalyseType,
                        callback: function ($$v) {
                          _vm.selectedAnalyseType = $$v
                        },
                        expression: "selectedAnalyseType",
                      },
                    })
                  : _vm._e(),
                !_vm.modalInfo.isEdit
                  ? _c("c-input-old", {
                      staticClass: "m-document-create-edit-content-select",
                      class: {
                        "m-document-create-edit-content-select-required":
                          _vm.errorMessages.analyse.length,
                      },
                      attrs: {
                        required: _vm.errorMessages.analyse,
                        items: _vm.analysesList,
                        searchable: true,
                        clearable: true,
                        type: "select",
                        "floating-label": "Анализ",
                      },
                      model: {
                        value: _vm.selectedAnalyse,
                        callback: function ($$v) {
                          _vm.selectedAnalyse = $$v
                        },
                        expression: "selectedAnalyse",
                      },
                    })
                  : _vm._e(),
                _c("c-input", {
                  ref: "createEditDocumentDate",
                  staticClass: "m-document-create-edit-content-date",
                  class: {
                    "m-document-create-edit-content-date-required":
                      _vm.errorMessages.analyseDate.length > 0,
                    resend: _vm.modalInfo.isEdit,
                  },
                  attrs: {
                    required: _vm.errorMessages.analyseDate,
                    "input-text-condition": _vm.errorMessages.analyseDate,
                    "icon-right": true,
                    editable: true,
                    label: _vm.modalInfo.isEdit
                      ? "Дата пересдачи"
                      : "Дата сдачи",
                    type: "date",
                    icon: "calendar",
                    format: "DD.MM.YYYY, dddd",
                    placeholder: "00.00.0000",
                  },
                  on: { invalidDate: _vm.sendErrorDateMessage },
                  model: {
                    value: _vm.dateOfAnalyse,
                    callback: function ($$v) {
                      _vm.dateOfAnalyse = $$v
                    },
                    expression: "dateOfAnalyse",
                  },
                }),
                _c("c-input-old", {
                  staticClass: "m-document-create-edit-content-textarea",
                  attrs: {
                    type: "textarea",
                    clearable: true,
                    "max-length": "500",
                    "floating-label": "Комментарий",
                  },
                  model: {
                    value: _vm.analyseComment,
                    callback: function ($$v) {
                      _vm.analyseComment = $$v
                    },
                    expression: "analyseComment",
                  },
                }),
                _vm.appendLocalFiles.length > 0
                  ? _c(
                      "viewer",
                      {
                        staticClass: "m-document-create-edit-content-photos",
                        attrs: {
                          images: _vm.appendLocalImages.map((img) => img.url),
                        },
                      },
                      _vm._l(_vm.appendLocalFiles, function (file, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass:
                              "m-document-create-edit-content-photos-item",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-column align-content-center justify-content-center",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "m-document-create-edit-content-photos-item-container",
                                  },
                                  [
                                    file.format === "jpg" ||
                                    file.format === "jpeg" ||
                                    file.format === "png" ||
                                    file.format === "gif"
                                      ? _c(
                                          "div",
                                          { staticClass: "img-wrapper" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "svg-wrapper" },
                                              [
                                                _c("svg-icon", {
                                                  attrs: {
                                                    name: "eye",
                                                    size: 32,
                                                    color: "white",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c("img", {
                                              staticClass:
                                                "m-document-create-edit-content-photos-item-photo",
                                              attrs: { src: file.url },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    file.format === "docx" ||
                                    file.format === "doc" ||
                                    file.format === "pdf"
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "svg-wrapper docsDownload",
                                            attrs: {
                                              href: file.href,
                                              download: "",
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _c("svg-icon", {
                                              attrs: {
                                                name: "upload-light",
                                                color: "white",
                                                size: 24,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    file.format === "docx" ||
                                    file.format === "doc"
                                      ? _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "33",
                                              height: "33",
                                              viewBox: "0 0 33 33",
                                              fill: "none",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M26.8035 8.296L24.3795 25H17.9475L16.4595 13L14.8035 25H8.5155L6.1875 8.296H11.1315L12.1875 21.424L13.9635 8.296H19.1235L20.6115 21.424L22.0515 8.296H26.8035Z",
                                                fill: "#2B579A",
                                              },
                                            }),
                                            _c("path", {
                                              attrs: {
                                                d: "M1.5 31.5V1.5H31.5V31.5H1.5Z",
                                                stroke: "#2B579A",
                                                "stroke-width": "3",
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    file.format === "pdf"
                                      ? _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "33",
                                              height: "33",
                                              viewBox: "0 0 33 33",
                                              fill: "none",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M1.5 31.5V1.5H31.5V31.5H1.5Z",
                                                stroke: "#E30000",
                                                "stroke-width": "3",
                                              },
                                            }),
                                            _c("path", {
                                              attrs: {
                                                d: "M18.4486 14.7397C17.205 15.7354 17.1654 15.7596 16.431 16.3868C15.6967 17.014 15.4226 17.1035 14.1731 18.0923M18.4486 14.7397C22.6951 13.107 23.8297 9.49956 20.8864 8.43992C17.943 7.38027 16.3731 10.9298 18.4486 14.7397ZM18.4486 14.7397C18.7117 16.2779 18.7225 16.2654 18.8943 17.2736C19.0695 18.3012 19.0607 18.4132 19.3329 19.95M14.1731 18.0923C15.6889 18.6333 16.7871 19.0334 16.7871 19.0334C16.7871 19.0334 17.8203 19.4006 19.3329 19.95M14.1731 18.0923C10.584 15.3615 6.77769 16.2174 7.29796 19.2059C7.81822 22.1944 11.7902 21.731 14.1731 18.0923ZM19.3329 19.95C23.8993 20.1552 26.1933 23.2073 23.7703 25.1362C21.3472 27.065 18.6614 24.2047 19.3329 19.95Z",
                                                stroke: "#E30000",
                                                "stroke-width": "2",
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "m-document-create-edit-content-photos-item-name",
                                  },
                                  [_vm._v(_vm._s(file.name))]
                                ),
                              ]
                            ),
                            _c("c-button", {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.html",
                                  value: {
                                    container: "#app",
                                    trigger: "hover blur",
                                    content: "Удалить",
                                    placement: "top",
                                  },
                                  expression:
                                    "{\n                container: '#app',\n                trigger: 'hover blur',\n                content: 'Удалить',\n                placement: 'top',\n              }",
                                  modifiers: { html: true },
                                },
                              ],
                              staticClass:
                                "m-document-create-edit-content-photos-item-trash",
                              attrs: { size: "iconic", icon: "trash" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeImage(index, file.name)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _c("input", {
                  ref: "writeExplanatoryFileUpload",
                  attrs: {
                    id: "m-write-file-upload",
                    name: "attachment[]",
                    type: "file",
                    accept:
                      ".doc, .docx, image/gif, image/jpeg, image/png, .pdf",
                    hidden: "",
                    multiple: "",
                  },
                  on: { change: _vm.onFileChange },
                }),
                _c("c-button", {
                  staticClass: "m-document-create-edit-content-add-photo",
                  class: {
                    "m-document-create-edit-content-add-photo-photos-not-empty":
                      _vm.appendLocalFiles.length > 0,
                    "m-document-create-edit-content-add-photo-required":
                      _vm.isFileExceedsAllowedSize,
                  },
                  attrs: {
                    disabled: _vm.appendLocalFiles.length === 20,
                    icon: { icon: "plus", color: "primary" },
                    label: "Добавить файл",
                    size: "small",
                  },
                  on: { click: _vm.chooseFiles },
                }),
                _c("transition", { attrs: { name: "fade" } }, [
                  _vm.isFileExceedsAllowedSize
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "m-document-create-edit-content-photos-error-message",
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "14",
                                height: "14",
                                viewBox: "0 0 14 14",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("circle", {
                                attrs: {
                                  cx: "7",
                                  cy: "7",
                                  r: "6.5",
                                  fill: "white",
                                  stroke: "#FF238D",
                                },
                              }),
                              _c("circle", {
                                attrs: {
                                  cx: "7",
                                  cy: "10",
                                  r: "1",
                                  fill: "#FF238D",
                                },
                              }),
                              _c("rect", {
                                attrs: {
                                  x: "6",
                                  y: "3",
                                  width: "2",
                                  height: "5",
                                  rx: "1",
                                  fill: "#FF238D",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "m-document-create-edit-content-photos-error-message-text",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.isFileExceedsAllowedSize
                                      ? "Файл не может быть больше 50МБ"
                                      : "Выберите файл"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ],
              1
            ),
            _c("div", {
              staticClass: "m-document-create-edit-content-shadow-bottom",
              attrs: { id: "m-document-create-edit-content-shadow-bottom" },
            }),
          ]),
          _c(
            "div",
            { staticClass: "m-document-create-edit-buttons" },
            [
              _c("c-button", {
                staticClass: "m-document-create-edit-buttons-cancel",
                attrs: { label: "Отменить" },
                on: { click: _vm.closeModal },
              }),
              _c("c-button", {
                staticClass: "m-document-create-edit-buttons-submit",
                attrs: { color: "primary", label: "Сохранить" },
                on: { click: _vm.submitDocument },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }